var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{domProps:{"innerHTML":_vm._s(_vm.text_tag.outerHTML)}})}
var staticRenderFns = []

export { render, staticRenderFns }